import Section from "../../section/Section";
import { noop } from "lodash";
import cc from "classcat";
import useResponsive from "../../../../../src/_hooks/useResponsive";
import useBotOnButton from "../../../../../src/_hooks/useBotOnButton";

const FooterNav = ({ title, items = [], className = "", ...props }) => (
	<div className="col-12 col-sm-6 col-md-3 pb-8 pb-md-0">
		<span className="font-size-lg d-block font-weight-bold text-underline text-black mb-5">{title}</span>
		<ul className="list-unstyled m-0">
			{items.map((item, index) =>
				item.disabled ? null : (
					<li key={index} className={cc([{ "mb-2": index < items.length - 1 }])}>
						<a
							href={item.href}
							target={item.target || "_self"}
							onClick={item.onClick || noop}
							className="text-black text-no-underline font-size-lg"
						>
							{item.label}
						</a>
					</li>
				)
			)}
		</ul>
	</div>
);
const FooterNavItems = () => {
	const { trigger } = useBotOnButton("get-in-touch");

	return (
		<>
			<FooterNav
				title="Career Development"
				items={[
					{ label: "For Organisations", href: "/for-organisations/" },
					{ label: "For Individuals", href: "/for-individuals/" },
				]}
			/>

			<FooterNav
				title="Get inspired"
				items={[
					{ label: "Articles", href: "/blog/" },
					{ label: "Spark! Newsletter", href: "https://spark.staynimble.co.uk/signup" },
					{ label: "Podcast", href: "https://podcasters.spotify.com/pod/show/staynimble" },
				]}
			/>

			<FooterNav title="Stay Nimble" items={[{ label: "Why choose us", href: "/who-we-are/" }]} />

			<FooterNav
				title="Help"
				items={[
					{ label: "FAQs", href: "/faqs/" },
					{
						label: "Contact us",
						href: "#",
						onClick: (e) => {
							e.preventDefault();
							trigger();
						},
					},
					{ label: "Terms & Conditions", href: "/terms-and-conditions/" },
					{ label: "Privacy Policy", href: "/privacy-policy/" },
				]}
			/>
		</>
	);
};

const FooterNavigation = () => {
	const isMobile = useResponsive();

	return (
		<Section className="pt-8 pb-15 pt-md-10 border-top border-dark">
			<div className="row justify-content-between">
				<FooterNavItems />
			</div>
		</Section>
	);
};

export default FooterNavigation;
